<div class="container-fluid">
  <div class="">
    <div class="row">
      <div class="col-sm-6">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="markLeadList" [rows]="10"
          [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]" [lazy]="true">
          <p-column field="serial" [style]="{'width': '5%'}" header="{{'SERIAL' | translate }}"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'doctorNameAr':'doctorNameEn'}}" [style]="{'width': '12%'}"
            header="{{ 'doctorName' | translate }}"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'leadTypeNameAr':'leadTypeNameEn'}}"
            [style]="{'width': '12%'}" header="{{ 'LEADTYPE' | translate }}"></p-column>
          <p-column [style]="{'width': '10%'}" header="{{ 'EXPECTEDDATE' | translate }}">
            <ng-template pTemplate="options" let-row="rowData">
              <i>
                {{row['regDate'] | date:'dd/MM/yyyy'}}
              </i>
            </ng-template>
          </p-column>
          <p-column [style]="{'width': '5%'}" header="{{ 'ACTIONS' | translate }}">
            <ng-template pTemplate="options" let-row="rowData">
              <icon-action (clicked)="onRowClick($event,row)" [appCodes]="[404]">
              </icon-action>
            </ng-template>
          </p-column>
        </p-dataTable>
      </div>

      <div class="col-sm-6">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="markLeadCallsList" [rows]="10"
          [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]" [lazy]="true">
          <p-column [style]="{'width': '6%'}" header="{{ 'EXPECTEDDATE' | translate }}">
            <ng-template pTemplate="options" let-row="rowData">
              <i>
                {{row['expectedDate'] | date:'dd/MM/yyyy'}}
              </i>
            </ng-template>
          </p-column>
          <p-column field="notes" [style]="{'width': '15%'}" header="{{ 'NOTES' | translate }}"></p-column>
        </p-dataTable>
      </div>
    </div>
  </div>
</div>